<!--
    @负责人: libaiqi
    @创建时间: 2018-10-12
    @版本:v1.0.23
    @描述: S3数据
    -->
<template>
  <div class="s3Record__content">
    <g-back :history="history"></g-back>
    <div class="s3Record__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('repertory.uri')">
          <el-input  v-model="form.uri"></el-input>
        </el-form-item>
        <el-form-item :label="$t('repertory.createTime')">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
          {{$t('common.to')}}
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-g-rac="gRac('repertory@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
    </el-table-extend>
  </div>
</template>
<script>
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import rac from '@/plugins/rac-mixin.js'
  import repertoryBiz from '@/logic/cmdb/repertoryBiz.js'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic, table, rac],
    components: {
    },
    data () {
      return {
        form: {
          startTime: '',
          endTime: '',
          uri: ''
        },
        history: []
      }
    },
    methods: {
      e_init () {
        this.history = []
        this.history.push({ name: this.$route.query.name, path: `/home/repertory/repertoryInstance?flagId=${this.$route.query.flagId}&resourceName=${this.$route.query.resourceName}&resourceType=3` })
        this.form.uri = ''
        this.form.startTime = new Date().getTime() - 24 * 60 * 60 * 1000
        this.form.endTime = new Date().getTime()
        this.initTable()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'repertory.table',
          head: ['uri', 'fileName', 'size', 'updateTime'],
          requestFun: this.search,
          headOpt: {}
        })
      },
      search () {
        const reqData = {
          id: this.$route.query.id,
          flagId: this.$route.query.flagId,
          ...this.form
        }
        repertoryBiz.getS3Record(reqData).then((d) => {
          if (d && d.dataList) {
            d.dataList.map((item) => {
              item.updateTime = TimeFormat.getFormatTime(item.updateTime)
            })
          }
          this.tData = d
        })
      }
    },
    mounted () {
      this.e_init()
    },
    watch: {
      $route (newV, oldV) {
        if (oldV.name === 'repertoryInstance' && newV.name === 's3Record') {
          this.e_init()
        }
      }
    }
  }
</script>
